import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { openSignupModal } from 'store/parts/signup-modal/actions';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  // store
  openSignupModal: PropTypes.func.isRequired
};

const SignupModalButton = props => {
  const { className, children, openSignupModal } = props;
  return (
    <button
      className={classnames('btn btn-tertiary', className)}
      onClick={() => openSignupModal()}
    >
      {children || 'Become a Member'}
    </button>
  );
};

SignupModalButton.propTypes = propTypes;

export default connect(null, { openSignupModal })(SignupModalButton);
